import { useState, useEffect, useMemo } from "react";
import requets from "../../../api";
import { useAppAuth } from "../../../context/use-app-auth";

export default function useGaugeConfig(devEui, measurementName, value, unit) {
  const auth = useAppAuth();
  const req = useMemo(() => requets(auth.user?.access_token), [auth.user?.access_token]);
  const [baseConfig, setBaseConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!devEui || !measurementName) return;

    const fetchConfig = async () => {
      setLoading(true);
      try {
        const response = await req.get(
          `/setting-threshold/gauge-config?devEui=${devEui}&measurementName=${measurementName}&value=${value ?? 0}&unit=${unit ?? ""}`
        );
        setBaseConfig(response.data);
      } catch (error) {
        console.error("Error fetching gauge config:", error);
        setBaseConfig(null);
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, [devEui, measurementName, value, unit, req]);

  const config = useMemo(() => {
    if (!baseConfig) return null;
    const max = baseConfig.max || 100;
    return {
      ...baseConfig,
      percent: max > 0 ? value / max : 0,
      axis: {
        ...baseConfig.axis,
        label: {
          ...baseConfig.axis?.label,
          formatter: (v) => (Number(v) * max).toFixed(0),
        },
      },
      statistic: {
        ...baseConfig.statistic,
        content: {
          ...baseConfig.statistic?.content,
          formatter: () => `${value} ${unit}`,
        },
      },
    };
  }, [baseConfig, value, unit]);

  return { config, loading };
}
